@use '@/styles/tokens' as *;

/** Two-column field grid (Figma 1795:148221 / 1795:160451). A single child lands in the
 *  left column, leaving the right column empty (e.g. external "Installation On"). */
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: var(--space-4);
  padding: 0 var(--space-6);
}

.title {
  margin: 0;
  font-size: $font-size-2xl;
  font-weight: $font-weight-regular;
  padding: 0 var(--space-6);
}

.switchButton {
  margin: 0 var(--space-6) 0;
  font-size: 14px;
}
